<template>
  <div class="feedbacklist">
    <header>
<!--      <div class="fl">只看我的</div>-->
      <div class="fr" @click="screen">筛选<van-icon name="arrow-down" size="0.13rem"/></div>
    </header>
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :no-data-text-data.sync="noDataText"
              @on-infinite="onInfinite"
              @on-refresh="onRefresh"
              class="my_scroller"
              ref="my_scroller"
    >
      <ul class="list">
        <li class="item" v-for="(item, index) of list" :key="index" @click="goDetail(item)">
          <img class="static" v-if="item.dealstatus == 1" src="../../assets/images/untreated.png">
          <img class="static" v-if="item.dealstatus == 0" src="../../assets/images/processed.png">
          <p>{{item.type}}</p>
          <div class="time">
            <span>反馈人：{{item.smallname}}</span>
            <span>{{item.addtime.replace(/-/g, '/')}}</span>
          </div>
          <div class="content">
            <div class="p">
              {{item.content}}
            </div>
            <img src="../../assets/images/jt2.png">
          </div>
        </li>
      </ul>
    </Scroller>
    <transition name="slide-fade">
      <div v-if="floatWindowShow" class="FloatWindow">
        <p @click="screen">筛选 <img src="../../assets/images/jt7.png"></p>
<!--        <div class="classification">-->
<!--          <p>问题范围</p>-->
<!--          <ul>-->
<!--            <li @click="elementClickSort(index)" :class="{elements: index!=eleIndexSort, tempElements: index==eleIndexSort}" v-for="(item, index) in domList[0].sort" :key="index">{{item}}</li>-->
<!--          </ul>-->
<!--        </div>-->
        <div class="classification">
          <p>问题类型</p>
          <ul>
            <li @click="elementClickTime(index)" :class="{elements: index!=eleIndexTime, tempElements: index==eleIndexTime}" v-for="(item, index) in domList[0].time" :key="index">{{item}}</li>
          </ul>
        </div>
        <div class="btn">
          <button class="element" @click="reset">重置</button>
          <button class="element" @click="confirm">确定</button>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div @click="screen" v-if="floatWindowShow" class="mask"></div>
    </transition>
  </div>
</template>

<script>
import Scroller from '../common/Scroller'
import { fenxiang } from '../../assets/common/js/config'
import { customRequestAjax } from '@/axiosApi'

export default {
  name: 'feedbackList',
  components: {
    Scroller
  },
  data: function () {
    return {
      list: [],
      domList: [
        {
          sort: ['只看我的', '查看全部'],
          time: ['产品问题', '订单问题', '平台使用', '用户体验', '活动问题', '内容', '其他']
        }
      ],
      eleIndexSort: -1,
      eleIndexTime: -1,
      floatWindowShow: false,
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——'
    }
  },
  witch: {
    eleIndexTime (n) {
      console.log('eleIndexTime', n)
    }
  },
  mounted: function () {
    fenxiang({path: 'feedbacklist'})
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter (to, from, next) {
    console.log(from)
    if (from.path == '/') { // 当前页面刷新不需要切换位置
      next(vm => {
        vm.nowPage = 0
      })
    } else {
      next(vm => {
        if (from.path == '/feedback') Object.assign(vm.$data, vm.$options.data())
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    if (to.path == '/feedback') this.loading = true
    next()
  },
  methods: {
    getData: function () {
      var that = this
      var url = 'Wxmall/User/getMyIdea?pageno=' + this.nowPage + '&pagesize=' + this.pagesize + '&range=' + parseInt(this.eleIndexSort + 1) + '&type=' + parseInt(this.eleIndexTime + 1)
      customRequestAjax(url)
        .then(function (res) {
          if (res.data.code == 200) {
            if (that.nowPage == 1) {
              that.list = res.data.list
              that.refresh = false
            } else {
              that.list = that.list.concat(res.data.list)
            }
            that.loading = false
            if (res.data.list.length < that.pagesize) {
              that.finished = true
            } else {
              that.finished = false
            }
          }
        })
    },
    elementClickSort: function (idx) {
      this.eleIndexSort = idx
    },
    elementClickTime: function (idx) {
      this.eleIndexTime = idx
    },
    goDetail: function (items) {
      this.$router.push({
        path: '/feedbackdetails',
        query: {
          id: items.id
        }
      })
    },
    // 重置按钮点击
    reset: function () {
      this.eleIndexSort = -1
      this.eleIndexTime = -1
    },
    // 浮窗的展现形式
    screen: function () {
      this.floatWindowShow = !this.floatWindowShow
    },
    // 确定按钮点击
    confirm: function () {
      this.floatWindowShow = false
      this.nowPage = 1
      this.list = []
      this.getData()
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.list = []
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData()
      // }, 400)
    }
  }
}
</script>

<style scoped lang="scss">
.feedbacklist {
  header {
    padding: 0.14rem 0.11rem;
    background: #ffffff;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 1;
    div {
      font-size: 0.13rem;
      color: #191818;
      line-height: 0.18rem;
    }
    .fl {
      float: left;
    }
    .fr {
      float: right;
    }
    &:after {
      content: '';
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }
  }
  .my_scroller {
    margin-top: 0.56rem;
  }
  .list {
    margin: 0 0.11rem;
    .item {
      background: #fff;
      margin-bottom: 0.1rem;
      border-radius: 0.04rem;
      padding: 0.11rem;
      position: relative;
      .static {
        width: 0.6rem;
        height: 0.6rem;
        position: absolute;
        right: 0;
        top: 0;
      }
      &:first-of-type {
        margin-top: 0.1rem;
      }
      p {
        font-size: 0.15rem;
        color: #333333;
        font-weight: 500;
        margin-bottom: 0.03rem;
      }
      .time {
        font-size: 0.11rem;
        color: #999999;
        margin-bottom: 0.07rem;
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        span {
          display: block;
          &:first-of-type {
            margin-right: 0.35rem;
            width: 34%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }
      .content {
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        justify-content: space-between;
        -webkit-justify-content: space-between;
        -moz-justify-content: space-between;
        -ms-justify-content: space-between;
        -o-justify-content: space-between;
        .p {
          color: #444444;
          font-size: 0.13rem;
          margin-right: 0.16rem;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        img {
          width: 0.05rem;
          height: 0.11rem;
        }
      }
    }
  }
}
.FloatWindow {
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 0.1rem 0.11rem 0;
  z-index: 2;
  >p{
    text-align: right;
    right: 0.11rem;
    top: 0.15rem;
    color: #191818;
    font-size: 0.13rem;
    line-height: 0.18rem;
    margin-bottom: 0.21rem;
    img {
      margin: 0.06rem 0 0.06rem 0.04rem;
      width: 0.08rem;
      height: 0.06rem;
      float: right;
    }
  }
  .classification {
    p{
      font-size: 0.12rem;
      color: #979797;
    }
    &:first-of-type ul {
      margin-right: 0.11rem;
    }
    &:nth-of-type(2) ul {
      margin-bottom: 0.42rem;
      li {
        margin-bottom: 0.1rem;
      }
    }
    ul {
      display: flex;
      display: -webkit-flex;
      display: -o-flex;
      display: -ms-flex;
      display: -moz-flex;
      flex-wrap: wrap;
      -webkit-flex-wrap: wrap;
      -moz-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
      -o-flex-wrap: wrap;
      margin: 0.1rem 0 0.15rem 0;
      li {
        font-size: 0.12rem;
        padding: 0.06rem 0.13rem;
        border-radius: 0.15rem;
        margin-right: 0.1rem;
        margin-bottom: 0.1rem;
        &.elements {
          color: #5E5E5E;
          background: #EEEFF4;
          border: 1px solid transparent;
        }
        &.tempElements {
          color: #FC0324;
          border: 1px solid #FC0324;
        }
      }

    }
  }
  .btn {
    display: flex;
    display: -webkit-flex;
    display: -o-flex;
    display: -ms-flex;
    display: -moz-flex;
    position: absolute;
    bottom: -0.46rem !important;
    left: 0;
    right: 0 !important;
    .element {
      display: block;
      width: 50%;
      border: none;
      border-top: 1px solid #EFEFEF;
      outline: none;
      font-size: 0.15rem;
      color: #292929;
      line-height: 0.46rem;
      background: #fff;
      &:last-of-type {
        color: #fff;
        border: none;
        border-top: 1px solid transparent;
        background:linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
        background: -webkit-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
        background: -o-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
        background: -ms-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
        background: -moz-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
        border-radius:0 0 0.04rem 0;
      }
    }
  }
}
.mask{
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background:rgba(0,0,0,1);
  opacity:0.69;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(-0.5rem);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/user/feedbackList.vue